/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsAppInfo
 */
export interface MelcoModelsAppInfo {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsAppInfo
     */
    version?: string | null;
}

export function MelcoModelsAppInfoFromJSON(json: any): MelcoModelsAppInfo {
    return MelcoModelsAppInfoFromJSONTyped(json, false);
}

export function MelcoModelsAppInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsAppInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'version': !exists(json, 'version') ? undefined : json['version'],
    };
}

export function MelcoModelsAppInfoToJSON(value?: MelcoModelsAppInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'version': value.version,
    };
}


